import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import { axios } from "../../../../Global";

export default function CandidateFileUpload({
  uploadFilePopupState,
  setUploadFilePopupState,
  allFiletypes = [],
  filesPopupState,
  setUpdateData,
  arrivalId,
}) {
  const [loading, setLoading] = useState();
  const [selectedFile, setSelectedFile] = useState("");
  const [fileType, setFileType] = useState(null);
  const [name, setName] = useState("");
  const [validationErrors, setValidationErrors] = useState([]);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [fileError, setFileError] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file_name", name);
      formData.append("file", selectedFile);
      formData.append("file_type", fileType);

      await axios
        .post(
          `/dashboard/arrival-notification/${arrivalId}/candidate-file-upload/${filesPopupState?.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          dispatch(
            setAppError({ msg: "File Added Successfully.", color: "success" })
          );
          setUpdateData((prev) => !prev);
          setLoading(false);
          setUploadFilePopupState({});
        })
        .catch((err) => {
          setLoading(false);
          dispatch(setAppError({ msg: err?.response?.data?.message }));
          const validationError = err?.response?.data?.validation_error;
          if (validationError) {
            if (validationError?.file?.length > 0) {
              setValidationErrors(validationError?.file || []);
              validationError?.file?.forEach((fileError) => {
                dispatch(setAppError({ msg: fileError }));
                setFileError(fileError);
              });
            }
          }
        });
    } catch (error) {
      dispatch(setAppError({ msg: error?.message }));
    }

    setLoading(false);
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        uploadFilePopupState.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-md w-full h-auto max-h-[30rem]  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col p-6 overflow-y-scroll">
        <h1 className="text-xl font-semibold self-start">Upload File</h1>

        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col justify-center items-center gap-3 my-3"
        >
          <div className="w-full flex flex-col gap-1">
            <label className="text-sm">File Name</label>
            <input
              type="text"
              required
              className="input input-sm input-bordered"
              placeholder="Enter a file name"
              defaultValue={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="w-full flex flex-col gap-1">
            <label className="text-sm">Select File Type</label>
            <select
              className="select select-sm select-bordered"
              value={fileType}
              onChange={(e) => setFileType(e.target.value)}
              required
            >
              <option value="">Select a File type</option>
              {allFiletypes.map((filetype) => (
                <option key={filetype?.id} value={filetype?.name}>
                  {filetype?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="w-full flex flex-col gap-1">
            <label className="text-sm">Upload File</label>
            <input
              type="file"
              onChange={handleFileChange}
              required
              className="file-input file-input-sm file-input-bordered"
            />
          </div>
          <div className="w-full text-red text-sm flex flex-col gap-1">
            {validationErrors.map((error, index) => (
              <p key={index}>{error}</p>
            ))}
          </div>

          <div className="flex gap-3 min-w-fit  w-full">
            <button
              className="p-1 max-w-sm w-full rounded-md ring-1 ring-slate-600"
              onClick={() => {
                setUploadFilePopupState((p) => ({ open: false }));
              }}
              type="button"
            >
              Cancel
            </button>
            <button
              className="p-1 max-w-sm w-full rounded-md ring-1 ring-red text-white bg-red"
              type="submit"
            >
              {loading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
